import ShipperSaveDetail from "@/classes/models/ShipperSaveDetail";
import API from "@/classes/global/API";
import Notification from "@/classes/component-classes/Notification";
import store from "@/store/index"

export async function useMapShipperSave(modelValue, route, isNewContact) {

    let section = new ShipperSaveDetail();

    section.id = modelValue.shipper.id;
    section.name = modelValue.shipper.shipperName ?? '';
    section.addressLine1 = modelValue.shipper.shipperAddressLine1;
    section.addressLine2 = modelValue.shipper.shipperAddressLine2 ?? '';
    section.city = modelValue.shipper.shipperCity ?? '';
    section.county = modelValue.shipper.shipperCounty ?? '';
    section.postCode = modelValue.shipper.shipperPostcode ?? '';
    section.country = modelValue.shipper.shipperCountry.split('-')[0] ?? '';
    section.vatNumber = modelValue.shipper.shipperVatNumber ?? '';
    section.contacts = modelValue.shipper.shipperContacts ?? [];
    section.isShipperAddress = true;

    modelValue.isUpdate.shipper = true;

    const addressDetail = await API.saveAddress('shipper', section, route)

    if (addressDetail) {

        store.state.hideLoadingSpinner = true;
        store.state.banners.success = new Notification(true, 'Information Saved Successfully');

        try {

            modelValue.shipper.id = addressDetail.id;
            modelValue.shipper.shipperContacts = addressDetail.contacts;

            // Check if new contact just added, set id from new returned record (last in list)
            if( modelValue.shipper.shipperContactId === 0) {

                modelValue.shipper.shipperContactId = addressDetail.contacts[addressDetail.contacts.length - 1].id;
                modelValue.newShipperCompany.shipperContactId = modelValue.shipper.shipperContactId;

            }


        } catch (error) {

            //TODO log error
        }

    }


}
